import * as React from 'react'
import {Box, Typography, Link} from "@mui/material";
import { IconSeeker } from "@ui-seeker/core"


import {ImageSkuBlock, SkuInfoBlock} from "@components";
import {MARKETPLACES_ROUTES} from '@constants';
import { useBuildExternalURL } from "@hooks"
import { currentPeriod, startDate, endDate, encodeCommonFiltersShareValue } from '@signals';


export default function skuColumn() {
	return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    },{
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    },{
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	},{
		name: 'skuName', label: 'Product Name',
		options: {
			filterType: 'textField',
			setCellHeaderProps: () => ({ sx: { minWidth: 200 }}),
			customBodyRowRenderLite: (value, row) => {
				const { category, brand, ean, siteID, productID, date, skuID, reference } = row
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })

				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock
							productID={productID}
							siteID={siteID}
							skuID={skuID}
							date={endDate.value}
							skuName={row.skuName}
						/>
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							category={category}
							brand={brand}
							ean={ean}
							asin={productID}
							reference={reference}
							productURL={productURL}
						/>

						<Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
							ASIN: {productID}
						</Typography>

						<GoToDetailsBlock filters={{
							sku: [row.skuID],
							retailer: [row.siteID],
							currentPeriod: currentPeriod.value,
							startDate: startDate.value,
							endDate: endDate.value
						}} />
					</Box>
				</Box>
			}
		}
	}]
}

const GoToDetailsBlock = ({filters}) => {
	const styles = {
        cursor: "pointer",
        display: "flex",
        marginTop: "0.6rem",
        columnGap: "3px",
        padding: "0.3rem",
        width: "max-content",
		alignItems: 'center'
    }

    return <Link 
		href={`${MARKETPLACES_ROUTES.LBBDETAILS_PATH}?sp=${encodeCommonFiltersShareValue(filters)}`} 
		target="_blank"
		sx={{ cursor: "pointer", color: 'text.primary', '&:hover':{ textDecoration: 'none'}  }}
	>
		<Box sx={styles}>
			<IconSeeker icon="circle-info" />
			<Typography variant="body2" sx={{ display: "inline", fontSize: "0.8rem", '&:hover':{ textDecoration: 'underline'} }}>
				Go to details
			</Typography>
		</Box>
	</Link>
}
